import DataSource from "devextreme/data/data_source";
import { client } from "shared/helpers/client";
import { useAuthContext } from "shared/context/auth-context";
import React, { useCallback, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";

export enum GrantedUserStatus {
  Current = 100,
  Active = 105,
  Inactive = 106,
  Invited= 3003
}

interface InviteUserData {
  email:string;
  grantedUserRoleTypeId:number;
  contactName?:string;
  jobDescription?:string,
  isActive:boolean
}

export function useGrantedUser(dataInv:InviteUserData) {
  const {t} = useTranslation();
  
  const {data:roles} = useQuery(['user-roles'], () => client('/ManageEmployee/GetEmployeeRoleType').then(r => r.response));

  const inviteUserForm = useForm<InviteUserData>({
    resolver:yupResolver(yup.object().shape({
      email:yup.string().required(t('errors.required')),
      grantedUserRoleTypeId:yup.number().required(t('errors.required')),
      contactName:yup.string(),
      jobDescription:yup.string(),
      isActive:yup.boolean()
    }))
  });

  const restInvForm = useCallback(()=>{
    inviteUserForm.reset({
      email:dataInv?.email ?? '',
      grantedUserRoleTypeId:dataInv?.grantedUserRoleTypeId,
      contactName:dataInv?.contactName ?? '',
      jobDescription:dataInv?.jobDescription ?? ''
    });
  },[dataInv, inviteUserForm])

  useEffect(()=>{
    if(dataInv){
      restInvForm()
    }
  },[dataInv, restInvForm])

  const grantedUserSource = React.useMemo(() => new DataSource({
    key:"id",
    load(options) {
      return client<any>("/ManageEmployee/GetPagedList", {
        params: {
          skipCount: options.skip,
          maxResultCount: options.take,
        },
      }).then((r) => r.response);
    }
  }),[]);

  const inviteUserServer = useMutation(user => client('/ManageEmployee/InviteNewEmployee',{data:user}));
  const updateUserServer = useMutation(user => client('/ManageEmployee/UpdateEmployee',{data:user}));
  const resendUserServer = useMutation(userId => client('/grantedUsers/resendInvitation',{params:{id:userId}, method:"POST"}));
  const deleteUserServer = useMutation(userId => client('/ManageEmployee/DeleteEmployee',{params:{employeeId:userId}}));
  return {
    roles,
    inviteUserForm,
    grantedUserSource,
    resendUserServer,
    inviteUserServer,
    updateUserServer,
    deleteUserServer
  }

}
